
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/enterprise/[category]",
      function () {
        return require("private-next-pages/enterprise/[category].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/enterprise/[category]"])
      });
    }
  